const AduLogika: React.FC = () => {
    return (
        <div className="text-justify py-4">
            <h2 className="text-xl font-semibold mb-3">⚙️ Serunya Kompetisi Coding: Lebih dari Sekadar Mengetik Kode!</h2>

            <p className="mb-4">
                Lomba coding merupakan ajang paling dinanti dalam dunia IT karena <span className="font-semibold text-gray-800">menggabungkan logika tajam, kecepatan berpikir, dan kerja sama tim</span> dalam satu paket menantang. Para peserta harus menyelesaikan serangkaian soal algoritma yang sering kali tak bisa diselesaikan hanya dengan kemampuan dasar.
            </p>

            <ul className="list-disc list-inside mb-4 space-y-2">
                <li>Soal-soal meliputi topik seperti sorting, graph, dan dynamic programming.</li>
                <li>Waktu terbatas membuat tekanan menjadi nyata.</li>
                <li>Tim harus pandai membagi tugas dan membaca strategi lawan.</li>
            </ul>

            <blockquote className="border-l-4 border-blue-500 pl-4 italic text-gray-600 mb-4">
                “Kadang bukan tim dengan kemampuan terbaik yang menang, tapi tim yang paling kompak dan tenang dalam tekanan.”
            </blockquote>

            <p className="mb-4">
                Kesalahan sekecil apapun seperti kurung yang tidak cocok atau logika yang salah urut dapat membuat solusi gagal total. Di sinilah <span className="font-medium">ketelitian dan mental kompetitif</span> benar-benar diuji.
            </p>

            <p className="mb-4">
                Tidak hanya itu, dalam lomba berformat tim, kolaborasi menjadi krusial. <span className="font-semibold">Tim yang sukses adalah mereka yang saling percaya dan mampu membagi peran secara efisien</span>, layaknya tim engineering profesional di dunia nyata.
            </p>

            <p>
                Dengan segala tantangan dan keseruannya, lomba coding menjadi wadah yang sempurna untuk <span className="font-semibold">mengasah kemampuan berpikir kritis dan kerja sama</span>. Tak heran banyak peserta yang menganggap ajang ini sebagai batu loncatan menuju dunia profesional di bidang teknologi.
            </p>
        </div>
    )
}
export default AduLogika